import React from 'react';
import styled from 'styled-components';
import PizzaGallery from '../components/pizzaGallery';
import pizza18 from '../images/pizza18.webp';
import pizza19 from '../images/pizza19.webp';
import pizza23 from '../images/pizza23.webp';
import pizza24 from '../images/pizza24.webp';

import Layout from '../layouts'
import SEO from '../components/seo'
import BG from '../components/bg'
import { Container } from 'reactstrap';

const StyledAbout = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  border-bottom: 1px solid ${({ theme }) => theme.buttonBorder};
`

const Title = styled.h1`
  margin-bottom: 1rem;
  font-size: 2.8rem;
  overflow-wrap: normal;
  max-width: 1200px;

  @media (min-width: 960px) {
    font-size: 3.8rem;
  }
`

const Section = styled.section`
  margin-bottom: 3rem;
  max-width: 1000px;
`

const SectionHeading = styled.h2`
  font-size: 2rem;
  margin-bottom: 1.2rem;
  color: ${({ theme }) => theme.colors.primary || '#114426'};

  @media (max-width: 960px) {
    font-size: 1.8rem;
  }
`

const Text = styled.p`
  font-size: 1.15rem;
  line-height: 1.8;
  margin-bottom: 1.2rem;
  text-align: left;

  @media (max-width: 768px) {
    text-align: center;
  }
`;

const List = styled.ul`
  margin: 0 0 1.5rem 1.2rem;
  padding: 0;
  list-style: disc;
  line-height: 1.8;

  li {
    margin-bottom: 0.8rem;
  }
`

const StyledTextContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.blackWhite};
  margin-top: -110px;
  padding: 3rem 2.5rem 4rem;
  min-height: 90vh;

  @media (max-width: 960px) {
    padding: 2rem 1.2rem 3rem;
    text-align: center;
  }
`

const PageContent = styled(Container)`
  max-width: 1080px;
  margin: 0 auto;
  padding-left: 0;
  padding-right: 0;
`

const ImageGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1.5rem;
  margin: 2rem 0;

  @media (max-width: 960px) {
    grid-template-columns: 1fr;
  }
`

const SideImage = styled.img`
  width: 100%;
  height: 320px;
  object-fit: cover;
  border-radius: 22px;
  box-shadow: 0 20px 45px rgba(0, 0, 0, 0.13);
`

const GalleryWrapper = styled.div`
  max-width: 1080px;
  margin: 0 auto;
  padding: 0 1rem 3rem;
`

const PizzaPage = props => {
  return (
    <Layout path={props.location.pathname}>
      <BG />

      <SEO title="Wieczór z pizzą" path={props.location.pathname} />
      <StyledTextContainer>
        <PageContent style={{ paddingTop: 100 }}>
          <Title>Wieczór z pizzą</Title>
          <Section>
            <SectionHeading>Warsztaty kulinarne z włoską pizzą</SectionHeading>
            <Text>
              Zapraszamy na wyjątkowy wieczór, podczas którego wspólnie stworzymy pizzę od podstaw. To spotkanie łączy przyjemność przygotowywania ciasta, kreatywność w doborze dodatków oraz przyjazną atmosferę idealną dla par, rodzin i grup przyjaciół.
            </Text>
            <ImageGrid>
              <SideImage src={pizza18} alt="Przygotowanie pizzy" />
              <SideImage src={pizza19} alt="Składniki pizzy" />
            </ImageGrid>
            <Text>
              Podczas warsztatów poznasz sekret na idealne ciasto, przygotujesz świeży sos i nauczysz się komponować smakowite dodatki, korzystając z lokalnych składników i sezonowych warzyw. Wszystko w kameralnej, naturalnej oprawie naszego obiektu.
            </Text>
          </Section>

          <Section>
            <SectionHeading>Co znajdziesz w programie?</SectionHeading>
            <List>
              <li>Przygotowanie ciasta na pizzę krok po kroku</li>
              <li>Własnoręczne komponowanie sosów i dodatków</li>
              <li>Porady dotyczące pieczenia w tradycyjnym piecu lub domowym piekarniku</li>
              <li>Degustacja kilku rodzajów pizzy w dobrym towarzystwie</li>
              <li>Opcje wegetariańskie i wegańskie, dopasowane do Twoich preferencji</li>
            </List>
            <ImageGrid>
              <SideImage src={pizza23} alt="Gotowa pizza" />
              <SideImage src={pizza24} alt="Pizza z pieca" />
            </ImageGrid>
            <Text>
              Nasz wieczór z pizzą to nie tylko gotowanie – to także czas na rozmowę, relaks i wspólną zabawę przy stole. Chcemy, żeby każdy uczestnik poczuł się zaangażowany i mógł zabrać do domu praktyczne pomysły na domową pizzę.
            </Text>
          </Section>

          <Section>
            <SectionHeading>Styl i atmosfera</SectionHeading>
            <Text>
              Wieczór odbywa się w przytulnej, naturalnej przestrzeni, gdzie ciepłe światło, świeże zioła i rustykalne dodatki tworzą wyjątkowy klimat. To idealna propozycja dla osób, które cenią sobie dobre jedzenie i wspólne spędzanie czasu.
            </Text>
            <Text>
              Zadbaliśmy o miejsce na zdjęcia, dzięki czemu łatwo zaplanujesz piękne ujęcia z przygotowań, zabawy i efektownych wypieków. Poniżej znajdziesz gotowy układ na zdjęcia, który możesz szybko wypełnić własnymi fotografiami.
            </Text>
          </Section>

          <Section>
            <SectionHeading>Galeria zdjęć</SectionHeading>

          </Section>
        </PageContent>

        <GalleryWrapper>
          <PizzaGallery />
        </GalleryWrapper>
      </StyledTextContainer>
    </Layout>
  )
}

export default PizzaPage
